import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingService } from '../error&timer/loading.service';
import { generateTipMessage } from '../services/tips';

@Component({
  selector: 'app-global-loader',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (loadingService.isLoading | async) {
    <div class="general-loader">
      <div class="container-spinner">
        <div class="lds-spinner">
          <img src="./assets/reservas.svg" alt="" />
        </div>
        <h3>
          {{ getTipMessage() }} <br />
          <br />
          <strong>{{ message }}</strong>
        </h3>
      </div>
    </div>
    }
  `,
  styles: [
    `
      .general-loader {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
      }

      .container-spinner {
        text-align: center;
        color: white;
      }

      .lds-spinner img {
        position: relative;
        animation: diagonal-shine 4s linear infinite;
        width: 64px;
        height: 64px;
      }

      @keyframes diagonal-shine {
        0% {
          opacity: 0.3;
        }
        25% {
          opacity: 1;
        }
        50% {
          opacity: 0.3;
        }
        75% {
          opacity: 1;
        }
        100% {
          opacity: 0.3;
        }
      }
    `,
  ],
})
export class GlobalLoaderComponent {
  @Input() message: string = 'Procesando su solicitud...';
  tipMessage: string;
  getTipMessage(): string {
    return this.tipMessage;
  }

  constructor(public loadingService: LoadingService) {
    this.tipMessage = generateTipMessage();
  }
}
